(function () {
  const N8N_WEBHOOK_URL = 'https://n8n.lidutech.net/webhook/crear-descuento-joy';
  const STORAGE_KEY = 'timer_discount_session';
  const TIMER_DURATION = 10 * 60;

  function getStored() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }
  function setStored(data) { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
  function clearStored() { localStorage.removeItem(STORAGE_KEY); }
  function secondsLeft(endTime) { return Math.max(0, Math.round((endTime - Date.now()) / 1000)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fetchDiscountCode() {
    return fetch(N8N_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ timestamp: Date.now() })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      return {
        code: data.code,
        endTime: Date.now() + TIMER_DURATION * 1000
      };
    });
  }

  // Intercepta checkout — un solo listener global con useCapture
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[name="checkout"], .cart__checkout-button, #cart-checkout-button, ' +
      '[data-cart-checkout-button], .cart-drawer__checkout, button[data-action="checkout"]'
    );
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var stored = getStored();
    var sLeft = stored ? secondsLeft(stored.endTime) : 0;

    if (sLeft > 0 && stored.code) {
      window.location.href = '/checkout?discount=' + stored.code;
    } else {
      clearStored();
      window.location.href = '/checkout';
    }
  }, true);

  function buildBanner() {
    var el = document.createElement('div');
    el.className = 'cart-timer-banner';
    el.id = 'cart-discount-timer-banner';
    el.innerHTML =
      '<div class="cart-timer-banner__top">' +
        '<span class="cart-timer-banner__icon" id="cdt-icon">⚡</span>' +
        '<span class="cart-timer-banner__title" id="cdt-title">¡Oferta exclusiva para ti!</span>' +
      '</div>' +
      '<p class="cart-timer-banner__desc" id="cdt-desc">' +
        'Completa tu compra en los próximos <strong>10 minutos</strong> y obtén un <strong>10% de descuento</strong> automático.' +
      '</p>' +
      '<div class="cart-timer-banner__timer-row" id="cdt-timer-row">' +
        '<span class="cart-timer-banner__label">Tiempo restante:</span>' +
        '<div class="cart-timer-banner__blocks">' +
          '<div class="cart-timer-banner__block">' +
            '<span class="cart-timer-banner__num" id="cdt-min">10</span>' +
            '<span class="cart-timer-banner__unit">min</span>' +
          '</div>' +
          '<span class="cart-timer-banner__sep">:</span>' +
          '<div class="cart-timer-banner__block">' +
            '<span class="cart-timer-banner__num" id="cdt-sec">00</span>' +
            '<span class="cart-timer-banner__unit">seg</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    return el;
  }

  function updateDisplay(sLeft) {
    var banner = document.getElementById('cart-discount-timer-banner');
    if (!banner) return;
    banner.classList.remove('expired');
    if (sLeft <= 0) {
      banner.classList.add('expired');
      document.getElementById('cdt-icon').textContent = '🕐';
      document.getElementById('cdt-title').textContent = 'Oferta expirada';
      document.getElementById('cdt-desc').innerHTML = 'El tiempo de oferta ha expirado. ¡La próxima vez completa tu compra a tiempo!';
      document.getElementById('cdt-timer-row').style.display = 'none';
    } else {
      document.getElementById('cdt-min').textContent = pad(Math.floor(sLeft / 60));
      document.getElementById('cdt-sec').textContent = pad(sLeft % 60);
    }
  }

  var timerInterval = null;

  function startTick(endTime) {
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(function () {
      var s = secondsLeft(endTime);
      updateDisplay(s);
      if (s <= 0) clearInterval(timerInterval);
    }, 1000);
  }

  function injectBanner(endTime) {
    if (document.getElementById('cart-discount-timer-banner')) return;
    var selectors = ['.cart-drawer__footer', '.cart__footer', '[data-cart-footer]', '.drawer__footer'];
    var container = null;
    for (var i = 0; i < selectors.length; i++) {
      container = document.querySelector(selectors[i]);
      if (container) break;
    }
    if (!container) return;
    var banner = buildBanner();
    container.insertBefore(banner, container.firstChild);
    updateDisplay(secondsLeft(endTime));
    startTick(endTime);
  }

  function initSession() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          clearStored();
          if (timerInterval) clearInterval(timerInterval);
          var b = document.getElementById('cart-discount-timer-banner');
          if (b) b.remove();
          return;
        }

        var stored = getStored();

        if (stored && stored.code && secondsLeft(stored.endTime) > 0) {
          // Sesión activa — reutilizar código existente
          injectBanner(stored.endTime);
        } else {
          // Nueva sesión — pedir código fresco a n8n
          clearStored();
          fetchDiscountCode()
            .then(function (data) {
              setStored(data);
              injectBanner(data.endTime);
            })
            .catch(function (err) {
              console.warn('Timer discount: error obteniendo código', err);
            });
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSession();
    document.addEventListener('cart:updated', initSession);
    document.addEventListener('cart:open', initSession);
    document.addEventListener('theme:cart:open', initSession);
  });

})();